import { reducerFromMap } from "../../libs/helpers/reducers";

import {
  INTERNATIONAL_INVEST_LOADING,
  INTERNATIONAL_INVEST_LOADED,
  INTERNATIONAL_INVEST_LOAD_ERROR,
} from "../../actions/registry/registry.international_invest.actions";

const reducer = {
  /*
   * INTERNATIONAL_INVEST LIST
   */
  [INTERNATIONAL_INVEST_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [INTERNATIONAL_INVEST_LOADED]: (state, { data }) => ({
    ...state,
    loading: false,
    data: data.data,
  }),
  [INTERNATIONAL_INVEST_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
};

export default reducerFromMap(reducer, {
  data: [],
});
